module.exports = __webpack_public_path__ + "static/media/04.5ffc5872.mp3";